<template>
  <div>
    <h2 class="header">
      <span class="title mb-2" >相关推荐</span>
    </h2>
    <ul class="list">
      <li class="list-item cursor-pointer" v-for="item in recommendListFilter" :key="item.no" @click="toArticle(item)">
      <!-- <li class="list-item cursor-pointer" v-for="item in recommendList" :key="item.no" @click="toArticle(item)"> -->
        <el-image class="w-28 h-17.5 block rounded mr-[14px]" fit="cover" :src="item.cover" />
        <div class="flex-1 flex flex-col justify-between">
          <h3 class="list-title">{{ item.title }}</h3>
          <p class="itemDesc">
            {{ item.pageviews }}万次观看
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default{
  props: {
    recommendList: {
      type:Array,
      default:[]
    },
  },
  computed: {
    recommendListFilter() {
      if(this.recommendList.length >= 5) {
        return this.recommendList.splice(0, 5)
      }else return this.recommendList
    }
  },
  methods:{
    toArticle(item){
      const url = this.$router.resolve({
        path: `/company/article/${item.no}`,
      })

      window.open(url.href,'_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-bottom: 0.75rem;
}
.title {
  font-weight: 600;
  font-size: 1.625rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.list {
  list-style: none;
}
.list-item {
  margin-bottom: 18px;
  display: flex;
}
.list-item .list-title {
  color: $color-black-2;
  font-weight: 500;
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.list-item .list-title:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.list-item .itemDesc {
  --tw-text-opacity: 1;
  color: rgba(151, 154, 168, var(--tw-text-opacity));
  font-size: 13px;
}
</style>
